// extracted by mini-css-extract-plugin
module.exports = {"filter":"rates-selector_filter__1Yclb","counter":"rates-selector_counter__29nEH"};